import React from 'react';
import { FileText, Target, Zap, TrendingUp } from 'lucide-react';

const features = [
  {
    icon: FileText,
    title: 'Optimized Titles',
    description: 'Generate SEO-friendly meta titles that rank higher.'
  },
  {
    icon: Target,
    title: 'Industry Specific',
    description: 'Titles tailored for your website category and audience.'
  },
  {
    icon: Zap,
    title: 'Instant Generation',
    description: 'Get perfect meta titles in seconds with our AI tool.'
  },
  {
    icon: TrendingUp,
    title: 'Trend Analysis',
    description: 'Incorporate current SEO trends for better visibility.'
  }
];

export default function MetaFeatures() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
          Why Choose Our Meta Title Generator?
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="text-center p-6 rounded-lg border border-emerald-200 hover:shadow-lg transition-shadow">
              <feature.icon className="w-12 h-12 text-emerald-500 mx-auto mb-4" />
              <h3 className="text-xl font-semibold text-gray-900 mb-2">{feature.title}</h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}